import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Button,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import logo from "../assets/logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { gold, logoblue } from "../assets/styles";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = (state) => () => setOpen(state);

  const menuItems = [
    { label: "HOME", path: "/" },
    { label: "ABOUT", path: "/about" },
    { label: "SERVICES", path: "" },
    { label: "OUR PROJECTS", path: "/projects" },
    { label: "GALLARY", path: "/gallary" },
    { label: "CONTACT US", path: "/contact" },
  ];

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#fff",
        color: gold,
        boxShadow: "0px 0.5px 4px rgba(0,0,0,0.05)",
        borderBottom: "1px solid #e6e1d9",
        overflowX: "hidden",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 2, md: 4 },
          flexWrap: "wrap",
          overflowX: "hidden",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: "serif",
            fontWeight: 700,
            letterSpacing: 2,
            color: "#A88742",
            textAlign: "left",
            flex: 1,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt="ARCSTUDIOZ"
            style={{
              height: 50, // change as needed
              objectFit: "contain",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          />
        </Typography>
        {/* LEFT SECTION */}
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            gap: 2,
            minWidth: 0,
          }}
        >
          {menuItems.map((item, i) => (
            <React.Fragment key={i}>
              <Button
                component={Link}
                to={item.path}
                sx={{
                  color: location.pathname === item.path ? "white" : gold,
                  bgcolor:
                    location.pathname === item.path ? gold : "transparent",
                  fontWeight: 500,
                  fontSize: { xs: "0.8rem", md: "0.9rem" },
                  whiteSpace: "nowrap",
                  ":hover": {
                    bgcolor: gold,
                    color: "white",
                  },
                }}
              >
                {item.label}
              </Button>

              <Divider
                orientation="vertical"
                flexItem
                sx={{ borderColor: logoblue }}
              />
            </React.Fragment>
          ))}
        </Box>
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            gap: 2,
            minWidth: 0,
            ml:2
          }}
        >
          <IconButton href="https://instagram.com" sx={{ color: gold }}>
            <InstagramIcon />
          </IconButton>
          <IconButton href="https://linkedin.com" sx={{ color: gold }}>
            <LinkedInIcon />
          </IconButton>
          <IconButton href="mailto:info@arcstudioz.com" sx={{ color: gold }}>
            <EmailIcon />
          </IconButton>
        </Box>

        {/* MOBILE MENU BUTTON */}
        <IconButton
          sx={{ display: { xs: "flex", sm: "none" }, color: gold }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* MOBILE DRAWER */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 220, p: 2 }}>
          <List>
            {menuItems.map((item, index) => (
              <ListItem
                button
                key={index}
                component={Link}
                to={item.path}
                onClick={toggleDrawer(false)}
                sx={{
                  bgcolor:
                    location.pathname === item.path ? gold : "transparent",
                  color: location.pathname === item.path ? "white" : gold,
                  borderRadius: 1,
                  mb: 1,
                }}
              >
                <ListItemText
                  primary={item.label}
                  sx={{
                    textAlign: "center",
                  }}
                />
              </ListItem>
            ))}
          </List>
          <Divider sx={{ my: 1, borderColor: logoblue }} />
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <IconButton href="https://instagram.com" sx={{ color: gold }}>
              <InstagramIcon />
            </IconButton>
            <IconButton href="https://linkedin.com" sx={{ color: gold }}>
              <LinkedInIcon />
            </IconButton>
            <IconButton href="mailto:info@arcstudioz.com" sx={{ color: gold }}>
              <EmailIcon />
            </IconButton>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
